"use client";

import { RequireAuth } from "@workspace/ui/components/require-auth";
import { GenerateForm } from "../components/generate-form";

export default function Page() {
  return (
    <RequireAuth>
      <GenerateForm />
    </RequireAuth>
  );
}
